export var PartyRestrictionTypeEnum;
(function (PartyRestrictionTypeEnum) {
    PartyRestrictionTypeEnum[PartyRestrictionTypeEnum["INFUSION"] = 0] = "INFUSION";
    PartyRestrictionTypeEnum[PartyRestrictionTypeEnum["REPLICATED"] = 1] = "REPLICATED";
})(PartyRestrictionTypeEnum || (PartyRestrictionTypeEnum = {}));
